import api from 'api';

export const loadStatuses = api('GET /api/business-partners/filters/statuses');

export const loadPartnerCompanies = api(
  'POST /api/business-partners/filters/partner-company'
);

export const loadCustomerCompanies = api(
  'GET /api/business-partners/filters/customer-companies'
);

export const loadNetworks = api('GET /api/business-partners/filters/networks');

export const loadInvoiceLevels = api(
  'GET /api/business-partners/filters/invoice-levels'
);

export const loadCurrencies = api(
  'GET /api/business-partners/filters/currencies'
);

export const loadExpenseTypes = api(
  'GET /api/business-partners/filters/expense-types'
);

export const loadOwners = api('GET /api/business-partners/filters/owners');

export const loadCreators = api('GET /api/business-partners/filters/creators');
